// src\stores\reducers\todos.ts
// import { CONNECT_WALLET } from './../../constants';
// import { IWallet } from './../types'



// const wallet = (state: IWallet = {connected: 0}, action: { type: string; value: any }) => {
//   switch (action.type) {
//     case CONNECT_WALLET:
//       return  {
//         ...state,
//         ...action.value
//       };
//     default:
//       return state;
//   }
// };

// export default wallet;

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IUser, IBalance } from '../types';

interface UserState extends IUser {
  token: string | object;
}

interface BlanceState extends IBalance {
  bnb: string | number;
  usdt: string | number;
  bnbWei: string | number;
  usdtWei: string | number
}

const initialState: BlanceState & UserState = {
  token: '',
  bnb: 0,
  usdt: 0,
  bnbWei: 0,
  usdtWei: 0
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    login: (state, action: PayloadAction<UserState>) => {
      state.token = action.payload.token;
    },
    loadBalance: (state, action: PayloadAction<BlanceState>) => {
      state.bnb = action.payload.bnb;
      state.usdt = action.payload.usdt;
      state.bnbWei = action.payload.bnbWei;
      state.usdtWei = action.payload.usdtWei;
    }
  }
});

export const { login, loadBalance } = userSlice.actions;

export default userSlice;